import { Suspense, lazy } from "react";
import Banner from "../components/Banner";

const Faq = lazy(() => import("../components/Faq.js"));
const Benefits = lazy(() => import("../components/Benefits.js"));
const Footer = lazy(() => import("../components/Footer.js"));

function Homepage() {
  return (
    <Suspense fallback={<>Loading...</>}>
      <Banner />
      <Benefits />
      <Faq />
      <Footer />
    </Suspense>
  );
}

export default Homepage;
